import React from 'react';
import get from 'lodash/get';
import styled from 'styled-components/macro';

import Page from 'components/Page';
import SVGSelector from 'components/SVGSelector';


const LevelSelector = ({ page, currentLevel, onSelect }) => {
	const image = get(page.acf.image, 'sizes.main', null);
	const svg = get(page.acf.overlay, 'url', null);

	return (
		<Page>
			<LevelStyledSVGSelector 
				image={image}
				svg={svg}
				sizing="fill"
				onSelect={onSelect}

				$currentLevel={currentLevel}
			/>
		</Page>
	);
};


export default LevelSelector;


const LevelStyledSVGSelector = styled(SVGSelector)`
	width: 100%;
	height: 100%;
	overflow: hidden;

	.area_outline, .area-outline {
		fill: transparent;
		opacity: .7;
		transition: all .3s;
	}

	${props => props.$currentLevel && `
		#${props.$currentLevel} *:is(.area_outline, .area-outline) {
			fill: ${props.theme.primary_color};
			opacity: .6;
		}
	`}

	.area:hover *:is(.area_outline, .area-outline) {
		fill: ${props => props.theme.primary_color} !important;
		opacity: .8 !important;
	}
`;

